module.exports = __webpack_public_path__ + "img/扶梯4.f0709288.png";